var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.653,
    height: 15.957,
    viewBox: "0 0 17.653 15.957",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "x",
    transform: "translate(-2.346 -2.791)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1896",
    "data-name": "Path 1896",
    d: "M97.968,100h2.707l-5.914,6.759,6.957,9.2H96.27L92,110.379l-4.882,5.578H84.413l6.326-7.23L84.064,100H89.65l3.857,5.1Zm-.95,14.337h1.5l-9.682-12.8h-1.61Z",
    transform: "translate(-81.718 -97.209)",
    fill: "#b07f4a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.c2d466f14ef7d0310568d385aa4cd894.svg";
export { ForwardRef as ReactComponent };